import styles from './index.module.scss';
import { img, utility } from '@phi/components';
import phi_earphones from '../../phi-earphones.webp';
import { h } from 'vue';

export const PhiEarphones = h('div', { class: [ utility.h_inherit, utility.p_2 ] },
    img(phi_earphones, 'Sample earphones 3d design, made in Phi', [
        utility.h_inherit,
        utility.rounder,
        styles.earphones,
    ])
);
